import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "break-words",
  style: {"max-width":"900px","overflow-wrap":"anywhere"}
}
const _hoisted_2 = { class: "break-words" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Form = _resolveComponent("Form")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_DataTable, {
      columns: _ctx.tabelParams.columnsTable,
      endpoint: _ctx.tabelParams.endpoint,
      headerTitle: _ctx.tabelParams.headerTitle,
      buttonTitle: _ctx.tabelParams.buttonTitle,
      editTitle: _ctx.tabelParams.editTitle,
      deleteTitle: _ctx.tabelParams.deleteTitle,
      showColumnActivate: false,
      isDisableActive: true,
      confirmDialogDelete: _ctx.tabelParams.confirmDialogDelete,
      successToast: _ctx.onDeleteSuccessMessage,
      failedToast: _ctx.onDeleteFailedMessage
    }, {
      form: _withCtx(() => [
        _createVNode(_component_Form)
      ]),
      name: _withCtx(({ slotProps }) => [
        _createElementVNode("div", _hoisted_1, _toDisplayString(`${slotProps.data.name}`), 1)
      ]),
      reminderDaysBeforeExpiry: _withCtx(({slotProps}) => [
        _createTextVNode(_toDisplayString(`${slotProps.data.reminderDaysBeforeExpiry ?? 0} hari`), 1)
      ]),
      adjustmentType: _withCtx(({ slotProps }) => [
        _createElementVNode("div", _hoisted_2, _toDisplayString(`${slotProps.data.adjustmentType.toLowerCase() === 'increment' ? 'Surplus (+)' : 'Pengurang (-)'}`), 1)
      ]),
      _: 1
    }, 8, ["columns", "endpoint", "headerTitle", "buttonTitle", "editTitle", "deleteTitle", "confirmDialogDelete", "successToast", "failedToast"])
  ]))
}